<template lang="pug">
.Finale
  .congratulations
    svg(width="24px", height="24px")
      use(xlink:href="../assets/images/check-line.svg#check-line")
    p {{$t('congratulations')}} <br /> {{$t('you_validated_all_wishes')}}
  p.big-sentence(v-html="bigSentence")
  .wallpaper
    img(:src="wallpaperImg" alt="Download Rezo Zero Wallpaper")
    .buttons
      ShareBtn.sharebtn(:text="$t('share_message')")
      CustomBtn.downloadbtn(@click="downloadWallpaper"): svg(viewBox="0 0 330 330"  xmlns="http://www.w3.org/2000/svg")
        path(d="M154.4 265.6l1 1 .6.4.7.5.6.4.6.3.7.4.7.3.6.2.7.2.7.2.8.2.8.1.6.1a15.2 15.2 0 003 0h.6l.8-.2.8-.2c.2 0 .4 0 .7-.2l.7-.2.6-.2.7-.4.7-.3.6-.3.6-.4.7-.5.5-.4 1-1h.1l70-70a15 15 0 00-21.2-21.2L180 218.8V15a15 15 0 00-30 0v203.8l-44.4-44.4a15 15 0 10-21.2 21.2l70 70zM315 300H15a15 15 0 000 30h300a15 15 0 000-30z")
</template>

<script>
import MiniMap from '@/components/MiniMap'
import CustomBtn from '@/components/CustomBtn'
import ShareBtn from '@/components/ShareBtn'
import gsap from 'gsap'
import wallpaperImg from '@/assets/images/rz-wallpaper.jpg'
import i18n from '../i18n'

export default {
  name: 'finale',
  components: { MiniMap, ShareBtn, CustomBtn },
  data () {
    return {
      wallpaperImg
    }
  },
  methods: {
    downloadWallpaper () {
      const a = document.createElement('a')
      a.setAttribute('href', this.wallpaperImg)
      a.setAttribute('download', 'rz_wallpaper.jpg')
      this.$el.append(a)
      a.click()
      this.$el.removeChild(a)
    }
  },
  computed: {
    bigSentence () {
      return i18n.t('all_the_team') + ' <strong>' + i18n.t('wishes_you_a_nice_year') + '</strong>'
    }
  },
  mounted () {
    this.$store.commit('inDarkPage', true)
    this.$store.commit('hoverOnCard', false)

    const p = this.$el.querySelector('.big-sentence')
    const wp = this.$el.querySelector('.wallpaper')
    const cg = this.$el.querySelector('.congratulations')

    const tl = gsap.timeline()
    tl
      .to(cg, { autoAlpha: 0, duration: 4, delay: 1 }, 0.5)
      .from(p, { scale: 0.7, autoAlpha: 0, rotation: 0, duration: 1.5, ease: 'expo.out' }, 3.5)
      .from(this.$el, { backgroundColor: this.$store.state.colors.dark, duration: 1.5, ease: 'expo.out' }, 6)
      .add(() => this.$store.commit('inDarkPage', false), 7.5)
      .from(wp, { scale: 0.7, y: '-100vh', rotation: 90, duration: 1.5, ease: 'expo.out' }, 7.5)
  }
}
</script>

<style lang="scss">
.Finale {
  height: 100vh;
  background-color: $pink;
  padding: 24px;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  .minimap {
    position: absolute;
  }

  .big-sentence {
    font-family: $font-grand;
    font-size: 5vw;
    text-align: center;
    width: 90vw;
    max-width: 1440px;
    transform: rotate(-15deg) scale(1.15);
    margin: 0;
    margin-bottom: 50px;
    cursor: default;

    b {
      font-weight: 800;
    }

    @media (min-width:1440px) {
      font-size: 70px;
    }
  }

  .wallpaper {
    position: absolute;
    transform: rotate(-15deg);

    img {
      height: 60vh;
      object-fit: contain;
      background: $black;
      margin-top: 77px;
    }

    .buttons {
      text-align: center;

      button {
        color: $black;
        margin: 10px 5px;

        &.sharebtn {
          background-color: $white;
        }
      }
    }
  }

  .congratulations {
    text-align: center;
    font-family: $font-rz;
    line-height: 22px;
    position: absolute;
    top: 50vh;
    left: 50vw;
    z-index: 10;
    transform: translate(-50%, -50%);

    svg {
      padding: 12px;
      border: 1px solid rgba(255,255,255,0.5);
      border-radius: 100%;
    }
  }
}
</style>
